import { Checkbox } from '@mui/material';
import React, { useState } from 'react';
import styles from './Notification.module.scss';
import { Button } from 'tt-ui-lib/core';

export const Notification = (props) => {
  const { close, openModal, text, type, disableNotifications, ...restProps } = props;

  const [disableChecked, setDisableChecked] = useState(false);

  let backImg;
  if (type === 1) {
    backImg = "url('/images/templates/Notification1.png')";
  } else {
    backImg = "url('/images/templates/Notification2.png')";
  }

  const onClose = () => {
    if (disableChecked) {
      disableNotifications();
    }

    close();
  };

  return (
    <div {...restProps} className={styles.container} style={{ backgroundImage: backImg }}>
      <div className={styles.box}>
        <div className={styles.text}>
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      </div>
      <div className={styles.box}>
        <div className={styles.confirmCheckbox}>
          <div className={styles.checkbox}>
            <Checkbox
              size="small"
              sx={{
                color: 'white',
                '&.Mui-checked': {
                  color: 'white',
                },
              }}
              onChange={(e) => setDisableChecked(e.target.checked)}
            />
          </div>
          <div className={styles.text}> Turn off notifications </div>
        </div>
        <div className={styles.actions}>
          <Button className={styles.buttonSkip} type="link" onClick={onClose}>
            SKIP
          </Button>
          <Button className={styles.buttonProceed} type="invert" onClick={() => openModal()}>
            PROCEED
          </Button>
        </div>
      </div>
    </div>
  );
};
